import { apiRoutes } from "../services/apiRoutes";
import { htmlDecode } from "../services/Utils";

export const PublicSiteData = (props) => {
    const gridId_Search = 1;

    const listToTree = (list) => {
        var map = {}, node, roots = [], i;

        for (i = 0; i < list.length; i += 1) {
            map[list[i].phraseSection.phraseSectionTypeId] = i;
            list[i].children = [];
        }

        for (i = 0; i < list.length; i += 1) {
            node = list[i];
            if (node.phraseSection.phraseSectionType.parentPhraseSectionTypeId !== null) {
                let parent = list[map[node.phraseSection.phraseSectionType.parentPhraseSectionTypeId]];
                if (parent)
                    parent.children.push(node);
            } else {
                roots.push(node);
            }
        }
        return roots;
    }

    const base64ToArrayBuffer = (base64) => {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    const getData = async () => {
        let IsData = false;
        const newEditableCards = [];
        let sites = await props.execute("GET", apiRoutes.publicSites.get);
        if (sites && sites.length !== 0) {
            sites?.forEach((site, key) => {
                if (site.expiredAt != null)
                    site.expiredAt = new Date(new Date(site.expiredAt).toDateString());
                else if (site.apiToken != null && site.apiToken.expiredAt != null)
                    site.expiredAt = new Date(new Date(site.apiToken.expiredAt).toDateString());
                newEditableCards.push({ isEdit: false, site: site });
            });
            IsData = true
        }

        let tokens = await props.execute("GET", `${apiRoutes.tokens.get}?filters=IsEnabled==true`);
        const s = new Set(tokens);
        const options = [...s].map((x, i) => {
            return { value: x.id, label: htmlDecode(x.name) };
        });
        
        let filters = await props.execute("GET", apiRoutes.filter.GetFilters);
        for (var i = 0; i < filters.length; i++) {
            filters[i].label = htmlDecode(filters[i].filterName);
            filters[i].value = filters[i].id;
        }
        filters.unshift({ label: props.localizations.NoFilter ?? "-- No Filter --", value: 0 });

        let defaultTexts = await props.execute("GET", apiRoutes.defaultText.GetDefaultTexts);
        for (var i = 0; i < defaultTexts.length; i++) {
            defaultTexts[i].label = htmlDecode(defaultTexts[i].defaultTextName);
            defaultTexts[i].value = defaultTexts[i].defaultTextId;
        }
        defaultTexts.unshift({ label: props.localizations.NoDefaultText ?? "-- No Default Text --", value: 0 });

        return { filters, defaultTexts, options, newEditableCards, IsData};
    };

    const getCardData = async (publicSiteId) => {
        let newlogoUrl = "";

        let columns = await props.execute("GET", apiRoutes.column.GetPortalColumns(publicSiteId));
        let matColumns = [];
        let docColumns = [];
        if (columns != null) {
            for (var i = 0; i < columns.length; i++) {
                let title = columns[i].column.columnPropertyValues.find(x => x.columnPropertyId === 1).columnPropertyValue1;
                columns[i].title = title;
                if (columns[i].columnLocalizations.length > 0) {
                    let localizationEn = columns[i].columnLocalizations.find(x => x.localeId == 1033);
                    let localization = columns[i].columnLocalizations.find(x => x.localeId == props.languageValue.localeId);
                    if (localization)
                        columns[i].title = localization.localization;
                    else if (localizationEn)
                        columns[i].title = localizationEn.localization;
                    else
                        columns[i].title = columns[i].columnLocalizations[0].localization;

                    if (!columns[i].title)
                        columns[i].title = title;
                }
                if (!columns[i].title)
                    columns[i].title = columns[i].column.field;

                columns[i].field = columns[i].column.field;
                let alwaysShow = columns[i].column.columnPropertyValues.find(x => x.columnPropertyId === 4);
                columns[i].alwaysShow = alwaysShow != null && alwaysShow.columnPropertyValue1 === "true";

                columns[i].width = 200;
                columns[i].order = columns[i].columnOrder;
                if (columns[i].customerPortalColumns.length > 0) {
                    columns[i].selected = columns[i].customerPortalColumns[0].selected;
                    columns[i].order = columns[i].customerPortalColumns[0].order;
                    columns[i].width = columns[i].customerPortalColumns[0].width;
                }

                if (columns[i].column.gridId === gridId_Search)
                    matColumns.push(columns[i]);
                else
                    docColumns.push(columns[i]);
            }
        }

        let json = await props.execute("GET", apiRoutes.publicSites.GetSiteLogo(publicSiteId));
        if (json && json.logo) {
            var arrrayBuffer = base64ToArrayBuffer(json.logo);
            var blob = new Blob([arrrayBuffer], { type: 'image/png' });
            newlogoUrl = URL.createObjectURL(blob);
        }

        return { newlogoUrl, matColumns, docColumns };
    }

    const saveSite = async (e, selectedSite, materialColumns, documentColumns, selectedCard, PhraseSectionCustomer) => {
        let order = 1;
        let customerPortalColumns = [];
        for (var i = 0; i < materialColumns.length; i++) {
            if (materialColumns[i].customerPortalColumns.length === 0)
                materialColumns[i].customerPortalColumns.push({});
            materialColumns[i].customerPortalColumns[0].Order = order;
            order++;
            materialColumns[i].customerPortalColumns[0].customerPortalColumnId = 0;

            materialColumns[i].customerPortalColumns[0].width = materialColumns[i].width;
            materialColumns[i].customerPortalColumns[0].customerColumnId = materialColumns[i].customerColumnId;
            materialColumns[i].customerPortalColumns[0].selected = materialColumns[i].selected || materialColumns[i].alwaysShow;
            customerPortalColumns.push(materialColumns[i].customerPortalColumns[0]);
        }
        order = 1;
        for (var i = 0; i < documentColumns.length; i++) {
            if (documentColumns[i].customerPortalColumns.length === 0)
                documentColumns[i].customerPortalColumns.push({});
            documentColumns[i].customerPortalColumns[0].Order = order;
            order++;
            documentColumns[i].customerPortalColumns[0].customerPortalColumnId = 0;

            documentColumns[i].customerPortalColumns[0].width = documentColumns[i].width;
            documentColumns[i].customerPortalColumns[0].customerColumnId = documentColumns[i].customerColumnId;
            documentColumns[i].customerPortalColumns[0].selected = documentColumns[i].selected || documentColumns[i].alwaysShow;
            customerPortalColumns.push(documentColumns[i].customerPortalColumns[0]);
        }

        order = 1;
        PhraseSectionCustomer.forEach(x => {
            x.SortOrder = order++;
        });

        const postData = {
            url: selectedSite.url.replaceAll(" ", ""),
            name: selectedSite.name,
            description: selectedSite.description,
            apiTokenId: selectedSite?.apiToken.value,
            PortalColumns: customerPortalColumns,
            HeaderColor: props.colorValue,
            DefaultTextId: props.defaultTextSelected.defaultTextId,
            PortalCategories: PhraseSectionCustomer,
            logoData: props.selectedFile,
            updateLogo: props.updateLogo,
            filterSelected: props.filterSelected != null ? props.filterSelected.value : null,
            passwordProtected: selectedSite.passwordProtected,
            SecondaryHeaderColumnId: selectedSite.secondaryHeaderColumnId ?? null,
            TertiaryHeaderColumnId: selectedSite.tertiaryHeaderColumnId ?? null
        };

        let siteId = "00000000-0000-0000-0000-000000000000";
        if (selectedSite.id)
            siteId = selectedSite.id;

        let isdupe = await props.execute("GET", apiRoutes.publicSites.checkDuplicate(postData.url.replaceAll(" ", ""), siteId));

        if (isdupe && isdupe.success) {
            return -3;
        }

        if (selectedSite.id) {
            let returnVal = await updateSite(selectedSite, customerPortalColumns, selectedCard, PhraseSectionCustomer);
            return returnVal;
        }
        let response = await props.execute("POST", apiRoutes.publicSites.post, postData);
        if (!response || response.errorType != null) {
            return -1;
        } else if (response?.errorType === 'Validation') {
            return -2;
        }

        return {};
    };

    const updateSite = async (dataItem, customerPortalColumns, selectedCard, PhraseSectionCustomer) => {
        const updatedSite = { ...selectedCard };
        updatedSite.site.name = dataItem.name;
        updatedSite.site.description = dataItem.description;
        updatedSite.site.url = dataItem.url;
        updatedSite.site.apiToken = { id: dataItem.apiToken.id ?? dataItem.apiToken.value };
        updatedSite.site.passwordProtected = (dataItem.passwordProtected) ? 1 : 0;
        const putData = {
            url: selectedCard.site.url,
            name: selectedCard.site.name,
            description: selectedCard.site.description,
            apiTokenId: selectedCard?.site.apiToken?.id,
            PortalColumns: customerPortalColumns,
            HeaderColor: props.colorValue,
            DefaultTextId: props.defaultTextSelected.defaultTextId,
            PortalCategories: PhraseSectionCustomer,
            logoData: props.selectedFile,
            updateLogo: props.updateLogo,
            filterSelected: props.filterSelected != null ? props.filterSelected.value : null,
            passwordProtected: updatedSite.site.passwordProtected,
            SecondaryHeaderColumnId: dataItem.secondaryHeaderColumnId ?? null,
            TertiaryHeaderColumnId: dataItem.tertiaryHeaderColumnId ?? null
        };

        let response = await props.execute("PUT", apiRoutes.publicSites.put(selectedCard.site.id), putData);
        if (!response || response.errorType != null) {
            return -1;
        } else if (response?.errorType === 'Validation') {
            return -2;
        }
        return true;
    };

    return {
        getData, getCardData, saveSite, listToTree
    };
}